import { Delete, Edit } from '@workwave-tidal/core/icons'
import { useCallback } from 'react'

import { resetCrudSelection, useEditingStateWithCtx } from '@/atoms'
import { preview } from '@/components/form/preview'

import { DepotAvatar } from '../../../components/DepotAvatar'
import { useIsDepotLinkedToOrderSteps } from '../../../hooks/useIsDepotLinkedToOrderSteps'

import { useDeleteDepotModal } from '../../DeleteDepotModal'
import { useTexts } from '../hooks/useTexts'

type HeaderProps = {
  depot: uui.domain.client.rm.Depot
}

export function Header(props: HeaderProps) {
  const { depot } = props
  const texts = useTexts()
  const { Modal: DeleteDepotModal, show } = useDeleteDepotModal()
  const { setEditing } = useEditingStateWithCtx('depot')

  const depotCannotDeDeleted = useIsDepotLinkedToOrderSteps(depot.id)

  const onEdit = useCallback(() => setEditing([depot.id]), [setEditing, depot])
  const onReset = useCallback(() => {
    resetCrudSelection('depots')
  }, [])

  return (
    <preview.Header
      title={depot.name}
      testId="depot-view-header"
      avatar={<DepotAvatar depots={[depot]} size={44} />}
      onClose={onReset}
    >
      <preview.ActionBar>
        <preview.ActionBarItem
          icon={<Edit />}
          onClick={onEdit}
          label={texts.edit.title}
          disableWhenReadOnly
          tooltip={texts.edit.tooltip}
          testId="setup-depot__edit-button"
        />

        <preview.ActionBarItem
          icon={<Delete />}
          onClick={show}
          label={texts.delete.title}
          tooltip={texts.delete.tooltip(depotCannotDeDeleted)}
          testId="setup-depot__delete-button"
          disableWhenReadOnly
          disabled={depotCannotDeDeleted}
        />
      </preview.ActionBar>

      <DeleteDepotModal depotIds={[depot.id]} />
    </preview.Header>
  )
}
